export enum PortalType {
  DCR = "dcr",
  PAP = "pap",
}
